<template>
  <div ref="MANUAL_BILLING_DOCUMENT_LIST" :class="isCardView ? '' : 'section'">
    <section-header v-if="!hideTitle && !isCardView"
                    ref="MANUAL_BILLING_DOCUMENT_LIST"
                    :ressource="ressource"
                    :isExtended="extended"
                    :dialog="dialog"
                    :canAdd="canAdd"
                    :addLabel="addLabel"
                    :fiche=fiche
                    :showSearch=showSearch
                    :addDisabled=addDisabled
                    :show-toggle="showToggle"
                    @search=onSearchTextUpdated
                    @extended=setExtended
                    @closeDialog=closeSection
                    @cardView=cardView
                    @callback=addItem>
    </section-header>
    <list-header v-if="isCardView"
                 :placeholder="placeholder"
                 :showSearch=showSearch
                 :isCardView="isCardView"
                 :show-toggle="showToggle"
                 @cardView=cardView
                 @search=onSearchTextUpdated>
    </list-header>
    <div v-if="extended">
      <v-row class="ma-0 filters-row" no-gutters>
        <v-col v-for="(item, index) in headers.filter(h => getConfig(h.value).isFilterable)" cols="auto" :key="index" class="pr-2">
          <data-table-filter :headerValue="item.value"
                             :label="item.text"
                             :columnConfig="getConfig(item.value)"
                             :currentFilters="getFilters(item.value)"
                             @apply="applyFilters">
          </data-table-filter>
        </v-col>
      </v-row>
      <div v-if="!isCardView">
        <v-data-table-server v-model="selected"
                             dense fixed-header
                                   :headers="headers"
                                   :items="items"
                                   :items-per-page="-1"
                                   :must-sort="true"
                                   :mobile-breakpoint="100"
                                   class="white"
                                   :hover=true
                                   no-data-text="Aucune donnée"
                                   :return-object=true
                                   :disable-pagination="true"
                                   :hide-default-footer="true"
                                   :show-select="showSelect"
                                   v-model:sort-by="sortBy"
                                   @update:sortBy="onSortUpdate"
                                   @click:row="selectItem">
          <template v-slot:[`item.effectiveAt`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('effectiveAt', item.effectiveAt, item ) }}</div>
          </template>
          <template v-slot:[`item.ownerLabel`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('ownerLabel', item.ownerLabel, item ) }}</div>
          </template>
          <template v-slot:[`item.reference`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('reference', item.reference, item ) }}</div>
          </template>
          <template v-slot:[`item.kind`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('kind', item.kind, item ) }}</div>
          </template>
          <template v-slot:[`item.ledgerCode`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('ledgerCode', item.ledgerCode, item ) }}</div>
          </template>
          <template v-slot:[`item.amountTtc`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('amountTtc', item.amountTtc, item ) }}</div>
          </template>
          <template v-slot:[`item.statut`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('statut', item.statut, item ) }}</div>
          </template>
          <template v-slot:[`item.proposalReason`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('proposalReason', item.proposalReason, item ) }}</div>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-row class="m-0 flex-nowrap">
              <div v-if="hasDocument(item)" class="col-auto px-1">
                <v-icon :disabled="actionProgress" @click.stop="displayDocument(item)" size="25" :color="getDocumentColor(item)">{{mdiDocument(item)}}</v-icon>
              </div>
              <div v-if="canDelete(item)" class="col-auto px-1">
                <v-icon :disabled="actionProgress" @click.stop="deleteItem(item)" size="25" color="border">fas fa-trash-can</v-icon>
              </div>
              <div v-if="canUpdate(item)" class="col-auto px-1">
                <v-icon :disabled="actionProgress" @click.stop="updateItem(item)" size="25" :color="getUpdateColor(item)">{{mdiUpdate(item)}}</v-icon>
              </div>
              <div v-if="hasAction(item)" class="col-auto px-1">
                <v-icon :disabled="actionProgress" @click.stop="execAction(item)" size="25" :color="getActionColor(item)">{{mdiAction(item)}}</v-icon>
              </div>
            </v-row>
          </template>
          <template v-for="(item, index) in headers" v-slot:[`header.${item.value}`]>
            <div :key="index" style="display: flex; align-items: center;">
              <div>{{ item.text }}</div>
              <v-icon v-if="getSortOrder(item.value)" class="sort-icon">
                {{ getSortOrder(item.value) === 'asc' ? 'fas fa-arrow-up' : 'fas fa-arrow-down' }}
              </v-icon>
            </div>
          </template>
        </v-data-table-server>
        <v-row v-if="showCount" class="m-0">
          <v-col cols="11">
            <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" :total-visible="10" class="pagination-color"></v-pagination>
          </v-col>
          <v-col class="text-right align-content-center">
            {{ filteredCount }}/{{ totalCount }}
          </v-col>
        </v-row>
      </div>
    </div>
      <div v-if="!hasItems && isCardView" class="empty-list-container">
        <img src="@/assets/SVG/empty-list.svg" class="empty-list-logo"/>
        <div class="empty-list-label">{{ getNewLabel() }}</div>
      </div>
    <div class="pt-3" v-if="canAdd && isCardView">
      <v-btn class="base"
             :outlined="true"
             :loading="loading"
             :block="true"
             variant="flat"
             @click="addItem">
        {{ addLabel }}
      </v-btn>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :type="button.type"
                       :label="button.label"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <section-container :section="section"
                       :dialogOpen="dialogOpen"
                       :extended="true"
                       :fullscreen="fullscreen"
                       @closeDialog="closeDialog"
                       @saved="saved"
                       @updated="setUpdated">
    </section-container>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import ManualBillingDocument from '@/extend/classes/ManualBillingDocument';
  import { storeSession, storeManualBillingDocument } from '@/generated/stores';
  import { GenSection, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { Fiches } from '@/generated/classes/AppSchema';
  import Route from '@/extend/classes/Route';
  import DataTableFilter from '@/framework/base/components/DataTableFilter.vue';
  import ListBase from '@/framework/base/components/ListBase';
  import SectionContainer from '@/framework/base/components/SectionContainer.vue';
  import Section from '@/framework/base/classes/Section';
  import ListData from '@/extend/classes/ListData';
  import HubServices from '@/generated/hub/HubServices';

  export default defineComponent({
    extends: ListBase,
    components: {
      SectionHeader,
      SectionContainer,
      DataTableFilter
    },
    props: {
      hideTitle: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      fiche: {
        type: String,
      },
    },

    mounted(): void {
      HubServices.connection.invoke('EnterManualBillingDocument', storeSession.httpToken);
      HubServices.connection.on('ManualBillingDocumentCreated', this.reloadTable);
      HubServices.connection.on('ManualBillingDocumentUpdated', this.reloadTable);
      HubServices.connection.on('ManualBillingDocumentDeleted', this.reloadTable);
    },

    beforeUnmount(): void {
      HubServices.connection.off('ManualBillingDocumentCreated', this.reloadTable);
      HubServices.connection.off('ManualBillingDocumentUpdated', this.reloadTable);
      HubServices.connection.off('ManualBillingDocumentDeleted', this.reloadTable);
    },

    data() {
    const selected: ManualBillingDocument[] = [];
      return {
        selected,
        dialogOpen: false,
        isInitialised: false,
        actionProgress: false,
      }
    },

    computed: {
      ressource () { return RessourceGenSection(GenSection.MANUAL_BILLING_DOCUMENT_LIST); },

      headers() {
        return [
          { text: "Date du document", value: 'effectiveAt', cellClass: '', sortable: true },
          { text: "Nom", value: 'ownerLabel', cellClass: '', sortable: true },
          { text: "Référence", value: 'reference', cellClass: '', sortable: true },
          { text: "Nature", value: 'kind', cellClass: '', sortable: true },
          { text: "Type comptable", value: 'ledgerCode', cellClass: '', sortable: true },
          { text: "Montant TTC", value: 'amountTtc', cellClass: '', sortable: true },
          { text: "Statut", value: 'statut', cellClass: '', sortable: true },
          { text: "Motif de la proposition", value: 'proposalReason', cellClass: '', sortable: true },
          { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
        ];
      },

      items() : unknown[] {
        if (!this.isInitialised || (this.route && this.route.sectionObjId != this.lastRoute.sectionObjId)) {
          this.defaultFilter();
          this.setLastRoute();
          this.loadTable();
          this.isInitialised = true;
        }
        return this.listData.reccords;
      },

      showSearch() : boolean {
        return true;
      },

      hasItems() : boolean {
        return this.items.length > 0;
      },

      canAdd() : boolean {
        return true;
      },

      showCount() : boolean {
        return true;
      },

      addLabel() : string {
        return 'Ajouter';
      },

      addDisabled() : boolean {
        return false;
      },

      section(): Section {
        return new Section();
      }
    },

    methods: {
      loadTable (): void {
        if (this.loading) return;
        this.loading = true;
        ManualBillingDocument.list(this.filter).then((res) => {
          this.listData = new ListData();
          this.listData = res;
          this.pageNumber = res.currentPage;
          this.loading = false;
          if (this.isAbstract && res.reccords.length == 0 && this.canAdd) {
            this.addItem();
          }
        });
        this.pageNumber = 1;
      },

      setLastRoute() {
        this.lastRoute = Route.fromJson(this.route);
      },

      canUpdate(manualBillingDocument: ManualBillingDocument) : boolean {
        return manualBillingDocument.canUpdate;
      },

      mdiUpdate (manualBillingDocument: ManualBillingDocument): string {
        return 'fas fa-pencil';
      },

      getUpdateColor (manualBillingDocument: ManualBillingDocument): string {
        return 'border';
      },

      canDelete(manualBillingDocument: ManualBillingDocument) : boolean {
        return manualBillingDocument.canDelete;
      },

      mdiDocument (manualBillingDocument: ManualBillingDocument): string {
        return 'fas fa-file-pdf';
      },

      getDocumentColor (manualBillingDocument: ManualBillingDocument) : string {
        return '#F40F02';
      },

      hasDocument(manualBillingDocument: ManualBillingDocument) : boolean {
        return false;
      },

      displayDocument(manualBillingDocument: ManualBillingDocument) : void {
        //To implement
      },

      mdiAction (manualBillingDocument: ManualBillingDocument): string {
        return 'fas fa-arrow-pointer';
      },

      getActionColor  (manualBillingDocument: ManualBillingDocument): string {
        return '#1D6F42';
      },

      // eslint-disable-next-line
      hasAction(manualBillingDocument: ManualBillingDocument) : boolean {
        return false;
      },

      // eslint-disable-next-line
      execAction(manualBillingDocument: ManualBillingDocument) : void {
        //To implement
      },

      updateItem(item: unknown) : void {
        const obj = item as ManualBillingDocument;
        const route = new Route();
        route.fiche = Fiches.MANUAL_BILLING_DOCUMENT;
        route.ficheObjId = obj.id;
        this.$emit('selectItem', route);
      },

      selectItem(event: any, row: any): void {
        const obj = row.item as ManualBillingDocument;
        const route = new Route();
        route.fiche = Fiches.MANUAL_BILLING_DOCUMENT;
        route.ficheObjId = obj.id;
        this.$emit('selectItem', route);
      },

      addItem(): void {
        const obj = storeManualBillingDocument.createNewManualBillingDocument();
        const route = new Route();
        route.fiche = Fiches.MANUAL_BILLING_DOCUMENT;
        route.ficheObjId = obj.id;
        this.$emit('selectItem', route);
      },

      closeDialog(): void {
        this.dialogOpen = false;
      },

      closeSection(): void {
        this.$emit('closeDialog');
      },

      // eslint-disable-next-line
      saved(): void {
        // To implement
      },

      getNewLabel() : string {
        return ""
      }
    }
  })
</script>
